import { createSlice } from "@reduxjs/toolkit";
import { placeOrder } from "./checkout/placeOrder";
import { fetchContactEmail } from "./order/fetchContactEmail";
import { fetchOrder } from "./order/fetchOrder";
import { fetchOrderPoints } from "./order/fetchOrderPoints";
import { fetchPaymentMethod } from "./order/fetchPaymentMethod";
export const initialOrderState = {
    orderDetails: {
        fetchStatus: "idle",
        data: null,
    },
    orderNumber: undefined,
    contactEmail: undefined,
    paymentMethod: undefined,
    points: 0,
};
export const order = createSlice({
    name: "order",
    initialState: initialOrderState,
    reducers: {
        resetOrderNumber: (state) => {
            state.orderNumber = undefined;
        },
    },
    extraReducers: (builder) => {
        builder.addCase(fetchOrder.rejected, (state) => {
            state.orderDetails.fetchStatus = "error";
        });
        builder.addCase(fetchOrder.pending, (state) => {
            state.orderDetails.fetchStatus = "pending";
        });
        builder.addCase(fetchOrder.fulfilled, (state, action) => {
            state.orderDetails.fetchStatus = "success";
            state.orderDetails.data = action.payload;
        });
        builder.addCase(fetchPaymentMethod.fulfilled, (state, action) => {
            state.paymentMethod = action.payload;
        });
        builder.addCase(placeOrder.fulfilled, (state, action) => {
            state.orderNumber = action.payload.orderNumber;
        });
        builder.addCase(fetchContactEmail.fulfilled, (state, action) => {
            state.contactEmail = action.payload.personalInfo.email;
        });
        builder.addCase(fetchOrderPoints.fulfilled, (state, action) => {
            state.points = action.payload;
        });
    },
});
export const { resetOrderNumber } = order.actions;
//# sourceMappingURL=order.js.map